/* =========================================================
   MAISON ÊLYSÊA — TOP STICKY ADD TO BAG
========================================================= */

(() => {
  function initMaisonStickyCart() {
    const bar = document.querySelector('[data-maison-sticky-cart]');
    if (!bar) return;

    const sectionId = bar.dataset.sectionId;

    const productSection = document.querySelector(
      `#MainProduct-${CSS.escape(sectionId)}`
    );

    if (!productSection) return;

    const mainButton =
      productSection.querySelector('product-form button[type="submit"]') ||
      productSection.querySelector('.product-form__buttons button[type="submit"]');

    const stickyButton = bar.querySelector('[data-maison-sticky-submit]');
    const stickyButtonText = bar.querySelector('[data-maison-sticky-button-text]');
    const stickyPrice = bar.querySelector('[data-maison-sticky-price]');
    const stickyVariant = bar.querySelector('[data-maison-sticky-variant]');

    if (!mainButton || !stickyButton) return;

    /* Move the sticky bar directly under <body>.
       This prevents product-page containers from affecting position: fixed. */
    document.body.appendChild(bar);

    function updateVisibility() {
      const rect = mainButton.getBoundingClientRect();

      const shouldShow = rect.bottom < 0;

      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function updateProductInfo() {
      stickyButton.disabled = mainButton.disabled;

      if (stickyButtonText) {
        stickyButtonText.textContent =
          mainButton.disabled ? 'Sold Out' : 'Add to Bag';
      }

      const price =
        productSection.querySelector(
          `#price-${CSS.escape(sectionId)} .price-item--sale`
        ) ||
        productSection.querySelector(
          `#price-${CSS.escape(sectionId)} .price-item--regular`
        ) ||
        productSection.querySelector(
          `#price-${CSS.escape(sectionId)} .price-item`
        );

      if (price && stickyPrice) {
        const priceText = price.textContent.replace(/\s+/g, ' ').trim();

        if (priceText) {
          stickyPrice.textContent = priceText;
        }
      }

      if (stickyVariant) {
        const values = [];

        productSection
          .querySelectorAll(
            'select[name^="options"], .product-form__input input:checked'
          )
          .forEach((input) => {
            let value = '';

            if (input.tagName === 'SELECT') {
              value = input.options[input.selectedIndex]?.text || '';
            } else {
              value = input.value || '';
            }

            if (
              value &&
              value !== 'Default Title' &&
              !values.includes(value)
            ) {
              values.push(value);
            }
          });

        stickyVariant.textContent = values.join(' · ');
      }
    }

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled) return;

      mainButton.click();

      if (stickyButtonText) {
        stickyButtonText.textContent = 'Added to Bag';
      }

      window.setTimeout(() => {
        updateProductInfo();
      }, 1200);
    });

    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });

    window.addEventListener('resize', updateVisibility);

    productSection.addEventListener('change', () => {
      window.setTimeout(updateProductInfo, 100);
    });

    updateProductInfo();
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMaisonStickyCart);
  } else {
    initMaisonStickyCart();
  }
})();